/* media-library */
export const SET_ACCESSIBLE = 'setMediaLibraryAccessible'
export const SET_SHOW_MODAL = 'setMediaLibraryShowModal'
export const OPEN_MODAL = 'openMediaLibraryModal'
export const CLOSE_MODAL = 'closeMediaLibraryModal'
export const UPDATE_MEDIA_TYPE_TOTAL = 'updateMediaTypeTotal'
export const INCREMENT_MEDIA_TYPE_TOTAL = 'incrementMediaTypeTotal'
export const DECREMENT_MEDIA_TYPE_TOTAL = 'decrementMediaTypeTotal'
export const SAVE_MEDIAS = 'saveSelectedMedias'
export const UPDATE_MEDIAS = 'updateMedias'
export const DESTROY_MEDIAS = 'destroySelectedMedias'
export const REORDER_MEDIAS = 'reorderSelectedMedias'
export const PROGRESS_UPLOAD = 'progressUpload'
export const PROGRESS_UPLOAD_MEDIA = 'progressUploadMedia'
export const DONE_UPLOAD_MEDIA = 'doneUploadMedia'
export const ERROR_UPLOAD_MEDIA = 'errorUploadMedia'
export const DESTROY_SPECIFIC_MEDIA = 'destroyMediasInSelected'
export const UPDATE_MEDIA_MAX = 'updateMediaMax'
export const UPDATE_MEDIA_FILESIZE_MAX = 'updateMediaFilesizeMax'
export const UPDATE_MEDIA_WIDTH_MIN = 'updateMediaWidthMin'
export const UPDATE_MEDIA_HEIGHT_MIN = 'updateMediaHeightMin'
export const UPDATE_MEDIA_TYPE = 'updateMediaType'
export const RESET_MEDIA_TYPE = 'resetMediaType'
export const SET_MEDIA_CROP = 'setMediaCrop'
export const SET_MEDIA_METADATAS = 'setMediaMetadatas'
export const UPDATE_MEDIA_CONNECTOR = 'updateMediaConnector'
export const UPDATE_MEDIA_MODE = 'updateMediaMode'
export const DESTROY_MEDIA_CONNECTOR = 'destroyMediaConnector'
export const UPDATE_REPLACE_INDEX = 'updateReplaceIndex'
export const ADD_MEDIAS = 'addMedias'

export const UPDATE_IS_INSERTED = 'updateIsInserted'

export default {
  SET_ACCESSIBLE,
  SET_SHOW_MODAL,
  OPEN_MODAL,
  CLOSE_MODAL,
  UPDATE_MEDIA_TYPE_TOTAL,
  INCREMENT_MEDIA_TYPE_TOTAL,
  DECREMENT_MEDIA_TYPE_TOTAL,
  SAVE_MEDIAS,
  DESTROY_MEDIAS,
  REORDER_MEDIAS,
  PROGRESS_UPLOAD,
  PROGRESS_UPLOAD_MEDIA,
  DONE_UPLOAD_MEDIA,
  ERROR_UPLOAD_MEDIA,
  DESTROY_SPECIFIC_MEDIA,
  UPDATE_MEDIA_MAX,
  UPDATE_MEDIA_FILESIZE_MAX,
  UPDATE_MEDIA_WIDTH_MIN,
  UPDATE_MEDIA_HEIGHT_MIN,
  UPDATE_MEDIA_TYPE,
  RESET_MEDIA_TYPE,
  SET_MEDIA_CROP,
  SET_MEDIA_METADATAS,
  UPDATE_MEDIA_CONNECTOR,
  UPDATE_MEDIA_MODE,
  DESTROY_MEDIA_CONNECTOR,
  UPDATE_REPLACE_INDEX,
  UPDATE_MEDIAS,
  ADD_MEDIAS,

  UPDATE_IS_INSERTED
}
